import React from 'react';
import { useParams } from 'react-router-dom';
import { GuestTestFlow } from '../components';

/**
 * Guest test page component that wraps GuestTestFlow
 * This provides a clean URL structure for guest tests
 */
const GuestTest: React.FC = () => {
  const { sessionId } = useParams();

  return (
    <GuestTestFlow 
      sessionId={sessionId}
    />
  );
};

export default GuestTest;